class FeaturedPicksTabs extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.tabs = Array.from(this.querySelectorAll('[data-featured-picks-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-featured-picks-panel]'));
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index), { signal });
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
    });

    this.addEventListener(
      'shopify:block:select',
      (event) => {
        const blockId = event.detail?.blockId;
        if (!blockId) return;

        const index = this.tabs.findIndex((tab) => tab.dataset.featuredPicksTab === blockId);
        if (index >= 0) this.activate(index);
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this._initialized = false;
  }

  activate(index, { focus = false } = {}) {
    if (!this.tabs[index] || !this.panels[index]) return;

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    if (focus) this.tabs[index].focus();
  }

  onKeydown(event, currentIndex) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();

    let nextIndex = currentIndex;
    const isRtl = getComputedStyle(this).direction === 'rtl';

    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (event.key === 'ArrowRight') nextIndex = isRtl
      ? (currentIndex - 1 + this.tabs.length) % this.tabs.length
      : (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = isRtl
      ? (currentIndex + 1) % this.tabs.length
      : (currentIndex - 1 + this.tabs.length) % this.tabs.length;

    this.activate(nextIndex, { focus: true });
  }
}

if (!customElements.get('featured-picks-tabs')) {
  customElements.define('featured-picks-tabs', FeaturedPicksTabs);
}
